import React, {useEffect, useState} from "react";
import Heading from "../../../../components/dashboard/heading-component/Heading";
import JournalDetailCard from "../../../../components/dashboard/cards/journal-card/JournalDetailCard";
import {Col, Row} from "react-bootstrap";
import {GDateIcon, GStarIcon} from "../../../../../assets/icons/cardIcons";
import {useParams} from "react-router-dom";
import {JournalService} from "../../../../services/journals-api.service";
import dayjs from "dayjs";
import JournalDetailsSkeleton from "../../../skeletons/journals/journal-pages/JournalDetailsSkeleton";
import {useNavigate} from "react-router";
import {useJournal} from "../../../../providers/JournalContext";

export default function JournalDetails() {
  const [data, setData] = useState(null);
  const [loader, setLoader] = useState(true);
  let { id } = useParams();
  const { validateJournalPass, setValidateJournalPass } = useJournal();
  const navigate = useNavigate();

  async function GetJournal(id) {
    setLoader(true);
    const response = await JournalService.getSingleJournal(id);
    if (response?.data?.data?.status) {
      setData(response?.data?.data?.data.result);

      setLoader(false);
    }
  }
  useEffect(() => {
    GetJournal(id);
  }, []);

  if (validateJournalPass) {
    navigate("/journals/validate-password");
  }

  if (loader) {
    return <JournalDetailsSkeleton />;
  }

  return (
    <div className={"journal-details"}>
      {data && (
        <div>
          <Heading back={true} heading={"Journals"} />
          <Row className={"flex-column-reverse flex-md-row d-flex mt-5"}>
            <Col md={8}>
              {" "}
              <JournalDetailCard
                id={data?._id}
                data={data?.content}
                type={data?.type}
              />
            </Col>
            <Col md={4}>
              <div className={"icon-box"}>
                <div className={"icon"}>
                  <GDateIcon />
                </div>
                <div className={"content"}>
                  <h5>Date</h5>
                  <p>{dayjs(data?.createdAt).format("DD-MM-YYYY")}</p>
                </div>
              </div>
              <div className={"icon-box"}>
                <div className={"icon"}>
                  <GStarIcon />
                </div>
                <div className={"content"}>
                  <h5>Type</h5>
                  <p>{data?.type}</p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
}
